import * as React from "react";
import { useEffect } from "react";
import FrequentlyAskedQuestions from "../components/FrequentlyAskedQuestions.tsx";
import OracleAlgoPricing from "../components/OracleAlgoPricing.tsx";
import Oracle1 from "../components/Oracle1.tsx";
import Oracle2 from "../components/Oracle2.tsx";
import OracleTrustedBy from "../components/OracleTurstedBy.tsx";
import NavOracle from "../components/Navbar-oracle.tsx"
import FooterOracle from "../components/FooterOracle.tsx"

function Oracle() {
  useEffect(() => {
    // Change the body background color
    document.body.style.backgroundColor = "#F5F5F5"; // Black color

    // Cleanup to reset the background color when the component unmounts
    return () => {
      document.body.style.backgroundColor = ""; // Reset to default
    };
  }, []);
  return (
  <div className="h-full relative bg-black overflow-hidden z-0">
    {/* Background image inside, below all content */}
    <img src="images/hero-bg.png" className="absolute top-0 left-0 w-full z-5 h-[70vh]" />
   {/* <img src="images/video-bg.png" className="absolute top-[520px] left-0 w-full z-5" /> */}
    {/* Content container with higher z-index */}
    <div className="relative z-10">
      <NavOracle />
      <div className="flex flex-col items-center justify-center overflow-hidden">
        <Oracle1 />
        <Oracle2 />
      </div>
      <OracleTrustedBy />
      <div className="flex flex-col items-center justify-center mx-4 mt-20 py-20 bg-cover rounded-[35px] bg-center bg-no-repeat relative">
        <OracleAlgoPricing />
        {/* <JoinCommunity /> */}
      </div>
      <div className="pt-10 relative">
        <img src="images/faq-bg.png" className="absolute bottom-[65%] right-[-15%] lg:bottom-[15%] lg:right-[-25%] w-full -z-[2]" />
        <img src="images/footer-background.png" className="absolute bottom-[0] max-lg:h-[50vh] w-full -z-[2]" />
        <FrequentlyAskedQuestions textColor="white" />
        <FooterOracle />
        <div className="h-12 max-lg:hidden" />
      </div>
    </div>
  </div>
  );
}

export default Oracle;